import React from "react";
import Icon from "./Icon";

// Icons/Core/arrow-drop-up-line
function ArrowUp(props) {
  const svgPointsParameter = "12 11.828 9.172 14.657 7.757 13.243 12 9 16.243 13.243 14.828 14.657";
  return (<Icon {...props} svgPointsParameter={svgPointsParameter} />);
}

export default ArrowUp;
